import Modal from 'trunks/vue/admin/components/modals/modal.js'
import { newAlertify } from 'trunks/vue/admin/components/alert.js'

export default Vue.extend({
  components: {
    modal: Modal
  },

  props: {
    namespace: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      default: 'create'
    },
    superior: {
      type: Object,
      default() {
        return { name: '', identifier: '', phone: '' }
      }
    },
    onSuccess: {
      type: Function
    }
  },

  data() {
    return {
      form: {
        name: this.superior.name || '',
        identifier: this.superior.identifier || '',
        phone: this.superior.phone || ''
      },
      saving: false,
      errorTip: ''
    }
  },

  computed: {
    title() {
      return this.mode === 'edit' ? '编辑超级管理员' : '新建超级管理员'
    }
  },

  template: `
    <modal :title="title" extendClass="superior-modal" ref="modal">
      <div class="modal-body mt-4 mb-4">
        <div class="form-field required" :class="{ 'has-error': errorTip && !form.name }">
          <div class="form-field-head">
            <div class="form-field-title">姓名</div>
          </div>
          <div class="form-field-input-container">
            <div class="form-field-input">
              <input v-model.trim="form.name" class="form-field-value" type="text" placeholder="请输入姓名" />
            </div>
          </div>
        </div>

        <div class="form-field required" :class="{ 'has-error': errorTip && !form.identifier }">
          <div class="form-field-head">
            <div class="form-field-title">识别码</div>
          </div>
          <div class="form-field-input-container">
            <div class="form-field-input">
              <input v-model.trim="form.identifier" class="form-field-value" type="text" placeholder="请输入识别码" />
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="form-field-head">
            <div class="form-field-title">手机号</div>
          </div>
          <div class="form-field-input-container">
            <div class="form-field-input">
              <input v-model.trim="form.phone" class="form-field-value" type="text" placeholder="请输入手机号（可选）" />
            </div>
          </div>
        </div>

        <div class="form-error-message" v-if="errorTip">{{ errorTip }}</div>
      </div>

      <div slot="footer" class="modal-footer">
        <button class="outlined btn-default" @click="cancel">取消</button>
        <button @click="save" :disabled="saving">{{ saving ? '保存中...' : '保存' }}</button>
      </div>
    </modal>
  `,

  methods: {
    cancel() {
      this.$refs.modal.close()
    },

    save() {
      if (!this._validate()) return
      this.saving = true

      const payload = { superior: this.form }
      const baseUrl = this.namespace.urls.superiors
      const isEdit = this.mode === 'edit'
      const url = isEdit ? `${baseUrl}/${this.superior.id}` : baseUrl
      const method = isEdit ? 'patch' : 'post'

      Skylark.Libs.Ajax[method](url, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: payload,
        success: (data) => {
          newAlertify(isEdit ? '编辑成功' : '新建成功', { type: 'success' })
          if (this.onSuccess) this.onSuccess(data, { mode: this.mode })
          this.cancel()
        },
        error: (xhr) => {
          const errors = xhr && xhr.responseJSON && xhr.responseJSON.errors
          this.errorTip = errors ? errors.join('，') : '保存失败，请重试'
          newAlertify(this.errorTip, { type: 'error' })
        },
        complete: () => {
          this.saving = false
        }
      })
    },

    _validate() {
      if (!this.form.name || !this.form.identifier) {
        this.errorTip = '姓名和识别码必填'
        return false
      }
      this.errorTip = ''
      return true
    }
  }
})
